import { Text } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      color: theme.colorTextNeutralDefault,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      textAlign: 'center',
      textDecorationLine: 'underline',
      maxHeight: theme.sizingSmall,
      height: theme.sizingSmall,
    },
    variants: {
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {
          fontSize: theme.fontSizeThreeandhalfpulse,
        },
      },
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          size: 'ml',
        },
        css: {
          marginTop: 4,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightSmall
          ),
          textDecorationLine: 'underline',
        },
      },
      {
        variants: {
          size: 'md',
        },
        css: {
          marginTop: 7,
          lineHeight: convertLineHeight(
            theme.fontSizeThreepulse,
            theme.lineHeightMedium
          ),
          textDecorationLine: 'underline',
        },
      },
    ],
  }
})
